import {
  AbsoluteFill,
  Easing,
  interpolate,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";

export const InstagramVideo = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  // Scene 1: Text reveal (0-5 seconds)
  const scene1Opacity = interpolate(
    frame,
    [0, 30, 60],
    [0, 1, 1],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  // Scene 2: Staggered entrances (5-10 seconds)
  const scene2Opacity1 = interpolate(
    frame,
    [90, 120, 150],
    [0, 1, 1],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );
  
  const scene2Opacity2 = interpolate(
    frame,
    [130, 160, 190],
    [0, 1, 1],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );
  
  const scene2Opacity3 = interpolate(
    frame,
    [170, 200, 230],
    [0, 1, 1],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  // Scene 3: Final reveal with glow (10-15 seconds)
  const scene3Opacity = interpolate(
    frame,
    [270, 300, 450],
    [0, 1, 0],
    { extrapolateLeft: "clamp", extrapolateRight: "clamp" }
  );

  // Use Easing.spring for consistency with other files in this project
  const scene3Glow = interpolate(
    frame,
    [270, 300],
    [0, 60],
    { 
      extrapolateLeft: "clamp", 
      extrapolateRight: "clamp",
      easing: Easing.spring({ damping: 15, stiffness: 200 })
    }
  );

  return (
    <AbsoluteFill
      style={{
        backgroundColor: "black"
      }}
    >
      {/* Scene 1 */}
      <AbsoluteFill
        style={{
          opacity: scene1Opacity,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 48,
            color: "#D4AF37", // Champagne-gold color
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            textShadow: "0 0 10px rgba(212, 175, 55, 0.5)",
            transform: `translateY(${interpolate(frame, [0, 30], [50, 0], {
              easing: Easing.easeInOut,
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp"
            })}px)`,
          }}
        >
          Every Detail, Beautifully Crafted
        </div>
      </AbsoluteFill>

      {/* Scene 2 */}
      <AbsoluteFill
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 36,
            color: "#D4AF37", // Champagne-gold color
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            opacity: scene2Opacity1,
            marginBottom: 20,
            transform: `translateY(${interpolate(frame, [90, 120], [50, 0], {
              easing: Easing.easeInOut,
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp"
            })}px)`,
          }}
        >
          Custom Cake Toppers
        </div>
        
        <div
          style={{
            fontSize: 36,
            color: "#D4AF37", // Champagne-gold color
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            opacity: scene2Opacity2,
            marginBottom: 20,
            transform: `translateY(${interpolate(frame, [130, 160], [50, 0], {
              easing: Easing.easeInOut,
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp"
            })}px)`,
          }}
        >
          Wedding Mirrors
        </div>
        
        <div
          style={{
            fontSize: 36,
            color: "#D4AF37", // Champagne-gold color
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            opacity: scene2Opacity3,
            transform: `translateY(${interpolate(frame, [170, 200], [50, 0], {
              easing: Easing.easeInOut,
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp"
            })}px)`,
          }}
        >
          Personalized Gifts
        </div>
      </AbsoluteFill>

      {/* Scene 3 */}
      <AbsoluteFill
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontSize: 42,
            color: "#D4AF37", // Champagne-gold color
            fontFamily: "Arial, sans-serif",
            fontWeight: "bold",
            opacity: scene3Opacity,
            textShadow: `0 0 ${scene3Glow}px rgba(212, 175, 55, 0.8)`,
            transform: `translateY(${interpolate(frame, [270, 300], [50, 0], {
              easing: Easing.easeInOut,
              extrapolateLeft: "clamp",
              extrapolateRight: "clamp"
            })}px)`,
          }}
        >
          Akshar Creations PEI
        </div>
      </AbsoluteFill>
    </AbsoluteFill>
  );
};